export enum Steps {
  EditEmail = 'EditEmail',
  VerifyEmail = 'VerifyEmail',
  SuccessfullyChanged = 'SuccessfullyChanged',
}
